import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Empty } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { formatMessageTime, formatPrice } from "../../utils";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
`;

const Content = styled.div`
  padding: 12px;
`;

const Card = styled.div`
  background: #fff;
  padding: 12px;
  border-radius: 8px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
`;

const Label = styled.span`
  color: #7f7f7f;
`;

const Value = styled.span`
  color: #000;
  text-align: right;
  max-width: 65%;
  word-break: break-all;
`;

const WalletLogDetail = () => {
  const { params } = useNavigation();
  const detail = (params.walletLog as any) || null;

  if (!detail) {
    return (
      <PageWrap>
        <PageHeader title="流水详情" />
        <ScrollArea>
          <Empty description="流水信息不存在" style={{ padding: 40 }} />
        </ScrollArea>
      </PageWrap>
    );
  }

  return (
    <PageWrap>
      <PageHeader title="流水详情" />
      <ScrollArea>
        <Content>
          <Card>
            <Row>
              <Label>金额</Label>
              <Value>{formatPrice(detail.amount || 0)} 喜鹊币</Value>
            </Row>
            <Row>
              <Label>余额</Label>
              <Value>{formatPrice(detail.balance || 0)}</Value>
            </Row>
            <Row>
              <Label>订单号</Label>
              <Value>{detail.order_no || "-"}</Value>
            </Row>
            <Row>
              <Label>时间</Label>
              <Value>
                {formatMessageTime(new Date(detail.created)) ||
                  detail.created ||
                  "-"}
              </Value>
            </Row>
            <Row>
              <Label>备注</Label>
              <Value>{detail.note || "-"}</Value>
            </Row>
          </Card>
        </Content>
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(WalletLogDetail);
